namespace RioERP.Orders {
    export interface OrderBookRow {
        Id?: number;
        BookId?: number;
        ProductId?: number;
        OrderId?: number;
        IsActive?: boolean;
        BookEBookType?: number;
        BookNoOfPages?: number;
        BookCost?: number;
        BookTaxCategoryId?: number;
        BookIsActive?: boolean;
        BookInsertUserId?: number;
        BookInsertDate?: string;
        BookUpdateUserId?: number;
        BookUpdateDate?: string;
        BookBookName?: string;
        BookIsbn?: string;
        ProductProductName?: string;
        ProductDescription?: string;
        ProductSkuCode?: string;
        ProductEProductType?: number;
        ProductERioplayVersion?: number;
        ProductRioplayProductCode?: string;
        ProductDownloadUrl1?: string;
        ProductDownloadUrl2?: string;
        ProductHasPenDrive?: boolean;
        ProductHasBooks?: boolean;
        ProductHasCourier?: boolean;
        ProductNote?: string;
        ProductWeight?: number;
        ProductHeight?: number;
        ProductWidth?: number;
        ProductLength?: number;
        ProductEPackingType?: number;
        ProductGrossAmount?: number;
        ProductEOpens?: number;
        ProductEWatchTime?: number;
        ProductEValidity?: number;
        ProductEValidityType?: number;
        ProductValidTill?: string;
        ProductTotalAllowedDuration?: number;
        ProductAllowSerialKeyGeneration?: boolean;
        ProductAllowedDevices?: string;
        ProductIsLive?: boolean;
        ProductProcesOrderOnPaid?: boolean;
        ProductEAccessStatus?: number;
        ProductInAppDownload?: boolean;
        ProductHasVod?: boolean;
        ProductTemplateSerialKeyId?: number;
        ProductIsActive?: boolean;
        ProductInsertUserId?: number;
        ProductInsertDate?: string;
        ProductUpdateUserId?: number;
        ProductUpdateDate?: string;
        ProductVendorId?: number;
        ProductSupportInfo?: string;
        ProductProductQueryInfo?: string;
        ProductEShippedby?: number;
        ProductActivateSerialKey?: boolean;
        ProductIsCombo?: boolean;
        ProductProductIds?: string;
        ProductWebsiteUrl?: string;
        ProductTeacherName?: string;
        ProductRioPlayTenantId?: number;
        ProductSecretkey?: string;
        OrderCustomerId?: number;
        OrderOrderNumber?: string;
        OrderCustomerName?: string;
        OrderCustomerEmail1?: string;
        OrderCustomerEmail2?: string;
        OrderCustomerMobile1?: string;
        OrderCustomerMobile2?: string;
        OrderBillingAddress1?: string;
        OrderBillingAddress2?: string;
        OrderBillingCity?: string;
        OrderBillingStateId?: number;
        OrderBillingPincode?: number;
        OrderShippingToName?: string;
        OrderShippingAddress1?: string;
        OrderShippingAddress2?: string;
        OrderShippingCity?: string;
        OrderShippingStateId?: number;
        OrderShippingPincode?: number;
        OrderEOrderStatus?: number;
        OrderEShippingType?: number;
        OrderDiscountPer?: number;
        OrderOrderDate?: string;
        OrderESourceType?: number;
        OrderSourceName?: string;
        OrderEmailSendCount?: number;
        OrderIsEmailSent?: boolean;
        OrderEPaymentStatus?: number;
        OrderLastEmailSentDate?: string;
        OrderFranchiseeId?: number;
        OrderEOrderProcessBy?: number;
        OrderDiscountCoupon?: string;
        OrderDiscountAmount?: number;
        OrderGrossAmount?: number;
        OrderNetAmount?: number;
        OrderTaxableAmount?: number;
        OrderEShippingStatus?: number;
        OrderEInvoiceStatus?: number;
        OrderMailId?: number;
        OrderEPaymentType?: number;
        OrderGstin?: string;
        OrderExpectedShippingDate?: string;
        OrderEInvoiceTo?: number;
        OrderEFranchiseeDiscountType?: number;
        OrderEFranchiseeDiscount?: number;
        OrderFranchiseeDiscountValue?: number;
        OrderFranchiseeDiscountAmount?: number;
        OrderInvoiceCompanyId?: number;
        OrderShippingNote?: string;
        OrderSourceOrderNumber?: string;
        OrderIsActive?: boolean;
        OrderInsertUserId?: number;
        OrderInsertDate?: string;
        OrderUpdateUserId?: number;
        OrderUpdateDate?: string;
        OrderVendorId?: number;
        OrderTaxAmount?: number;
        OrderFreezeData?: boolean;
        OrderShippingProviderId?: number;
        OrderCurrencyId?: number;
        OrderCurrencyAmount?: number;
        OrderNetAmountAfterFrDiscount?: number;
        OrderBillingCountry?: string;
        OrderShippingCountry?: string;
        OrderMode?: number;
        OrderCalculationCurrency?: number;
        OrderNote?: string;
        OrderLevel?: number;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace OrderBookRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'Orders.OrderBook';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            BookId = "BookId",
            ProductId = "ProductId",
            OrderId = "OrderId",
            IsActive = "IsActive",
            BookEBookType = "BookEBookType",
            BookNoOfPages = "BookNoOfPages",
            BookCost = "BookCost",
            BookTaxCategoryId = "BookTaxCategoryId",
            BookIsActive = "BookIsActive",
            BookInsertUserId = "BookInsertUserId",
            BookInsertDate = "BookInsertDate",
            BookUpdateUserId = "BookUpdateUserId",
            BookUpdateDate = "BookUpdateDate",
            BookBookName = "BookBookName",
            BookIsbn = "BookIsbn",
            ProductProductName = "ProductProductName",
            ProductDescription = "ProductDescription",
            ProductSkuCode = "ProductSkuCode",
            ProductEProductType = "ProductEProductType",
            ProductERioplayVersion = "ProductERioplayVersion",
            ProductRioplayProductCode = "ProductRioplayProductCode",
            ProductDownloadUrl1 = "ProductDownloadUrl1",
            ProductDownloadUrl2 = "ProductDownloadUrl2",
            ProductHasPenDrive = "ProductHasPenDrive",
            ProductHasBooks = "ProductHasBooks",
            ProductHasCourier = "ProductHasCourier",
            ProductNote = "ProductNote",
            ProductWeight = "ProductWeight",
            ProductHeight = "ProductHeight",
            ProductWidth = "ProductWidth",
            ProductLength = "ProductLength",
            ProductEPackingType = "ProductEPackingType",
            ProductGrossAmount = "ProductGrossAmount",
            ProductEOpens = "ProductEOpens",
            ProductEWatchTime = "ProductEWatchTime",
            ProductEValidity = "ProductEValidity",
            ProductEValidityType = "ProductEValidityType",
            ProductValidTill = "ProductValidTill",
            ProductTotalAllowedDuration = "ProductTotalAllowedDuration",
            ProductAllowSerialKeyGeneration = "ProductAllowSerialKeyGeneration",
            ProductAllowedDevices = "ProductAllowedDevices",
            ProductIsLive = "ProductIsLive",
            ProductProcesOrderOnPaid = "ProductProcesOrderOnPaid",
            ProductEAccessStatus = "ProductEAccessStatus",
            ProductInAppDownload = "ProductInAppDownload",
            ProductHasVod = "ProductHasVod",
            ProductTemplateSerialKeyId = "ProductTemplateSerialKeyId",
            ProductIsActive = "ProductIsActive",
            ProductInsertUserId = "ProductInsertUserId",
            ProductInsertDate = "ProductInsertDate",
            ProductUpdateUserId = "ProductUpdateUserId",
            ProductUpdateDate = "ProductUpdateDate",
            ProductVendorId = "ProductVendorId",
            ProductSupportInfo = "ProductSupportInfo",
            ProductProductQueryInfo = "ProductProductQueryInfo",
            ProductEShippedby = "ProductEShippedby",
            ProductActivateSerialKey = "ProductActivateSerialKey",
            ProductIsCombo = "ProductIsCombo",
            ProductProductIds = "ProductProductIds",
            ProductWebsiteUrl = "ProductWebsiteUrl",
            ProductTeacherName = "ProductTeacherName",
            ProductRioPlayTenantId = "ProductRioPlayTenantId",
            ProductSecretkey = "ProductSecretkey",
            OrderCustomerId = "OrderCustomerId",
            OrderOrderNumber = "OrderOrderNumber",
            OrderCustomerName = "OrderCustomerName",
            OrderCustomerEmail1 = "OrderCustomerEmail1",
            OrderCustomerEmail2 = "OrderCustomerEmail2",
            OrderCustomerMobile1 = "OrderCustomerMobile1",
            OrderCustomerMobile2 = "OrderCustomerMobile2",
            OrderBillingAddress1 = "OrderBillingAddress1",
            OrderBillingAddress2 = "OrderBillingAddress2",
            OrderBillingCity = "OrderBillingCity",
            OrderBillingStateId = "OrderBillingStateId",
            OrderBillingPincode = "OrderBillingPincode",
            OrderShippingToName = "OrderShippingToName",
            OrderShippingAddress1 = "OrderShippingAddress1",
            OrderShippingAddress2 = "OrderShippingAddress2",
            OrderShippingCity = "OrderShippingCity",
            OrderShippingStateId = "OrderShippingStateId",
            OrderShippingPincode = "OrderShippingPincode",
            OrderEOrderStatus = "OrderEOrderStatus",
            OrderEShippingType = "OrderEShippingType",
            OrderDiscountPer = "OrderDiscountPer",
            OrderOrderDate = "OrderOrderDate",
            OrderESourceType = "OrderESourceType",
            OrderSourceName = "OrderSourceName",
            OrderEmailSendCount = "OrderEmailSendCount",
            OrderIsEmailSent = "OrderIsEmailSent",
            OrderEPaymentStatus = "OrderEPaymentStatus",
            OrderLastEmailSentDate = "OrderLastEmailSentDate",
            OrderFranchiseeId = "OrderFranchiseeId",
            OrderEOrderProcessBy = "OrderEOrderProcessBy",
            OrderDiscountCoupon = "OrderDiscountCoupon",
            OrderDiscountAmount = "OrderDiscountAmount",
            OrderGrossAmount = "OrderGrossAmount",
            OrderNetAmount = "OrderNetAmount",
            OrderTaxableAmount = "OrderTaxableAmount",
            OrderEShippingStatus = "OrderEShippingStatus",
            OrderEInvoiceStatus = "OrderEInvoiceStatus",
            OrderMailId = "OrderMailId",
            OrderEPaymentType = "OrderEPaymentType",
            OrderGstin = "OrderGstin",
            OrderExpectedShippingDate = "OrderExpectedShippingDate",
            OrderEInvoiceTo = "OrderEInvoiceTo",
            OrderEFranchiseeDiscountType = "OrderEFranchiseeDiscountType",
            OrderEFranchiseeDiscount = "OrderEFranchiseeDiscount",
            OrderFranchiseeDiscountValue = "OrderFranchiseeDiscountValue",
            OrderFranchiseeDiscountAmount = "OrderFranchiseeDiscountAmount",
            OrderInvoiceCompanyId = "OrderInvoiceCompanyId",
            OrderShippingNote = "OrderShippingNote",
            OrderSourceOrderNumber = "OrderSourceOrderNumber",
            OrderIsActive = "OrderIsActive",
            OrderInsertUserId = "OrderInsertUserId",
            OrderInsertDate = "OrderInsertDate",
            OrderUpdateUserId = "OrderUpdateUserId",
            OrderUpdateDate = "OrderUpdateDate",
            OrderVendorId = "OrderVendorId",
            OrderTaxAmount = "OrderTaxAmount",
            OrderFreezeData = "OrderFreezeData",
            OrderShippingProviderId = "OrderShippingProviderId",
            OrderCurrencyId = "OrderCurrencyId",
            OrderCurrencyAmount = "OrderCurrencyAmount",
            OrderNetAmountAfterFrDiscount = "OrderNetAmountAfterFrDiscount",
            OrderBillingCountry = "OrderBillingCountry",
            OrderShippingCountry = "OrderShippingCountry",
            OrderMode = "OrderMode",
            OrderCalculationCurrency = "OrderCalculationCurrency",
            OrderNote = "OrderNote",
            OrderLevel = "OrderLevel",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
